<template>
  <v-timeline-item fill-dot :color="props.color">
    <template #icon>
      <v-icon color="grey darken-1">comment</v-icon>
    </template>
    <v-row>
      <v-col>
        <vs-text-input
          data-test="comment-box"
          label="Type a comment here"
          multiline
          rows="1"
          :value="props.modelValue"
          :disabled="props.loading"
          @input="emit('update:modelValue', $event)"
        />
      </v-col>
      <v-col align-self="center" class="shrink send-icon">
        <vs-button
          icon="send"
          :loading="props.loading"
          :disabled="props.loading"
          type="primary"
          color="blue lighten-4"
          data-test="submit-form-comment"
          @click="submitComment"
        />
      </v-col>
    </v-row>
  </v-timeline-item>
</template>

<script setup lang="ts">
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import VsButton from '@/components/vision/VsButton.vue'

const props = withDefaults(
  defineProps<{
    color?: string
    loading?: boolean
    modelValue?: string
  }>(),
  {
    color: 'blue lighten-4',
    loading: false,
    modelValue: '',
  },
)

const emit = defineEmits<{
  (event: 'update:modelValue', value: string): void
  (event: 'submit', value: string): void
}>()

const submitComment = () => {
  if (!props.modelValue || props.loading) return
  emit('submit', props.modelValue)
}
</script>

<script lang="ts">
export default {
  // Lets Vue 2 use the Vue 3 v-model contract. This option can remain after the upgrade.
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
}
</script>

<style scoped>
.send-icon {
  padding-right: 44px;
}
</style>
